import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
export const EnabledDisabledTooltip = ({ rollingProgramme, scheduler, children }) => {
    const lastEnabledState = !!scheduler?.lastPersitedState?.rollingProgramme.enabled;
    const locallyCommitedState = !!rollingProgramme?.enabled;
    const inEditState = !!scheduler?.rollingProgramme.enabled;
    const is = lastEnabledState === locallyCommitedState && locallyCommitedState === inEditState;
    const willBe = locallyCommitedState === inEditState && inEditState !== lastEnabledState;
    const wouldBe = lastEnabledState === locallyCommitedState && locallyCommitedState !== inEditState;
    const lastEnabledStateText = lastEnabledState ? 'enabled' : 'disabled';
    const locallyCommitedStateText = locallyCommitedState ? 'enabled' : 'disabled';
    const inEditStateText = inEditState ? 'enabled' : 'disabled';
    let alternator = '';
    if (is) {
        alternator = `is currently ${lastEnabledStateText}`;
    }
    else if (willBe) {
        alternator = `will be ${locallyCommitedStateText}`;
    }
    else if (wouldBe) {
        alternator = `would be ${inEditStateText}`;
    }
    let message = `When last saved, this programme was ${lastEnabledStateText}. This programme ${alternator}.`;
    return (_jsx(Tooltip, { title: message, placement: "bottom", arrow: true, children: _jsx("span", { children: children }) }));
};
